import { Check, Plus } from "lucide-react";
import { brl } from "@/lib/api";

export const ItemCard = ({ item, selected, onToggle, showDetails = true }) => (
  <button type="button" onClick={() => onToggle(item.key)} data-testid={`item-card-${item.key}`} aria-pressed={selected}
    className={`group relative flex h-full flex-col overflow-hidden border p-6 text-left transition-[border-color,background-color,transform] duration-300 hover:-translate-y-0.5 ${selected ? "border-red-600 bg-red-950/30" : "border-[#273248] bg-[#111723] hover:border-slate-500"}`}>
    <span className={`absolute left-0 top-0 h-full w-1 transition-colors ${selected ? "bg-red-600" : "bg-transparent group-hover:bg-slate-600"}`} />
    <div className="flex items-start justify-between gap-4">
      <span className={`font-mono text-4xl font-bold leading-none ${selected ? "text-red-500" : "text-slate-600 group-hover:text-slate-400"}`}>{item.code}</span>
      <span className={`flex h-8 w-8 shrink-0 items-center justify-center border transition-colors ${selected ? "border-red-600 bg-red-600 text-white" : "border-slate-600 text-slate-400"}`}>
        {selected ? <Check className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
      </span>
    </div>
    <h3 className="mt-5 text-lg font-bold uppercase leading-tight text-white">{item.nome}</h3>
    {item.group !== "I" && <p className="mt-2 text-sm leading-relaxed text-slate-400">{item.group === "D" ? "Serviços previstos:" : item.descricao}</p>}
    {showDetails && item.detalhes?.length > 0 && item.group === "D" && (
      <ul className="mt-3 flex flex-wrap gap-1.5">
        {item.detalhes.map((d) => (
          <li key={d} className="border border-slate-700 bg-black/30 px-2 py-0.5 text-[11px] text-slate-300">{d}</li>
        ))}
      </ul>
    )}
    <div className="mt-auto flex items-end justify-between pt-5">
      <span className="font-mono text-[11px] uppercase tracking-wider text-slate-500">{selected ? "Selecionado" : "Selecionar"}</span>
      <span className="font-heading text-sm font-semibold text-slate-200" data-testid={`item-price-${item.key}`}>{brl(item.preco)}</span>
    </div>
  </button>
);
